<div class="sectionTitle">
  <fa-icon icon="user-cog"></fa-icon>
  Access
</div>

<form nz-form nzLayout="vertical" [formGroup]="form">
  <div nz-row nzGutter="16">
    <nz-col nzLg="14" nzMd="24" nzSm="24">
      <nz-form-item>
        <nz-row>
          <nz-form-label nzRequired>Scope</nz-form-label>
        </nz-row>
        <nz-form-control [nzValidateStatus]="form.controls.dealPartnerId" [nzErrorTip]="scopeErrorTip">
          <nz-tree-select
            [nzNodes]="scopeTreeNodes"
            [ngModel]="scopeKeys"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onScopeKeysChange($event)"
            nzCheckable
            nzCheckStrictly
            [nzDefaultExpandAll]="true"
            [nzShowExpand]="true"
            [nzMaxTagCount]="3"
            [nzDisabled]="!scopeTreeNodes.length"
            [nzTreeTemplate]="scopeNodeTemplate"
            nzPlaceHolder="Select an account"
            class="full-width"
            id="update_user_scope" data-testid="update_user_scope">
          </nz-tree-select>
          <ng-template #scopeNodeTemplate let-node>
            <span>{{ node.title }}</span>
            <nz-tag *ngIf="node.origin.scopeTag" [ngClass]="node.origin.scopeTag.cssClass" class="scope-node-tag">
              {{ node.origin.scopeTag.label }}
            </nz-tag>
          </ng-template>
          <ng-template #scopeErrorTip>
            <ng-container *ngIf="!anchorAccountId">Scope is required</ng-container>
            <ng-container *ngIf="isAdminWithPortfolios">
              An Admin covers its whole account and can't be limited to portfolios. Select the
              account itself, or change the role to Trader or Viewer.
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="10" nzMd="24" nzSm="24">
      <nz-form-item>
        <nz-row>
          <nz-form-label nzRequired>Role</nz-form-label>
        </nz-row>
        <nz-form-control [nzErrorTip]="'Role is required'">
          <nz-select formControlName="roleName" id="update_user_role_name" data-testid="update_user_role_name"
                     nzPlaceHolder="Select a role" class="full-width"
                     (ngModelChange)="revalidateScope()">
            <nz-option *ngFor="let role of roleOptions" [nzLabel]="role.name" [nzValue]="role.name"></nz-option>
          </nz-select>
          <div class="helper-text" *ngIf="roleDescriptions[selectedRoleName]">
            {{ roleDescriptions[selectedRoleName] }}
          </div>
          <div class="helper-text">The role applies across everything the scope reaches.</div>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </div>
</form>
